import {
    isAbTestVariant,
    getAbTestTrackingData,
} from 'dibs-buyer-layout/exports/clientABTestHelpers';
import tracking from 'dibs-tracking';

const EMBEDDED_OFFER_TEST_NAME = 'PDP_EMBEDDED_OFFER_FORM';

export const showPdpEmbeddedOfferTest = ({ isNegotiable }) => {
    return isNegotiable ? isAbTestVariant(document.cookie, EMBEDDED_OFFER_TEST_NAME) : false;
};

export const trackEmbeddedOfferTest = () => {
    const trackingData = getAbTestTrackingData(document.cookie, EMBEDDED_OFFER_TEST_NAME);
    tracking.trackAbTestEvent(trackingData, 'pdp');
};
